export const getUrlAlias = (url) => {
  const auxUrl =
    url[url.length - 1] === '/' ? url.substr(url, url.length - 1) : url;
  const splits = auxUrl.split('/');
  const alias = splits[splits.length - 1];
  return alias;
};
